module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w540.1bd982db.webp";